export function calcMembershipPrice(data) {
  const {applyType, dateStr} = data;
  const [y, m, d] = dateStr.split('-').map((it) => parseInt(it, 10));
  const monthsLeftPrice = (12 - m) * 1400;
  const partialMonth = d > 15;
  const thisMonthPrice = partialMonth ? 700 : 1400;
  const basePrice = applyType === 'new' ? 8000 : 4500;
  return {
    basePrice,
    regularMonths: 12 - m + 1 - (partialMonth ? 0.5 : 0),
    regularMonthsPrice: monthsLeftPrice + thisMonthPrice,
    totalPrice: basePrice + monthsLeftPrice + thisMonthPrice,
  };
}
